import BaseModal from 'components/Modals/BaseModal';
import DeviceGroupSettings from 'features/Integrations/features/ConnectedDeviceGroups/features/DeviceGroupSettings/index.web';
import { Device } from 'features/Integrations/features/ConnectedDevices/types/MonitoringStation_types';

type Props = {
  group: any | null;
  resolvedDeviceSettings: Device | null;
  stageOpen: boolean;
  usgsOpen: boolean;
  onSelectFromGroup: (id: number | string) => void;
  onClose: () => void;
};

const GroupModal = ({
  group,
  resolvedDeviceSettings,
  stageOpen,
  usgsOpen,
  onSelectFromGroup,
  onClose,
}: Props) => {
  return (
    <>
      <BaseModal
        show={!!group && !resolvedDeviceSettings && !stageOpen && !usgsOpen}
        handleShow={onClose}
        title={group?.name}
      >
        {group && (
          <DeviceGroupSettings group={group} onSelectDevice={onSelectFromGroup} onClose={onClose} />
        )}
      </BaseModal>
    </>
  );
};

export default GroupModal;
